import React from "react";

import Box from "components/common/Box";
import Text from "components/common/Text";

const FeatureBar = ({ features, classes }) => (
  <Box className={classes.featureBar}>
    {features.map((feature, index) => (
      <React.Fragment key={feature.title}>
        {index > 0 ? <Box className={classes.featureDivider} aria-hidden /> : null}
        <Box
          className={`${classes.featureItem} ${
            feature.icon || feature.iconSlot ? "" : classes.featureItemNoIcon
          }`}
        >
          {feature.icon ? (
            <Box
              component="img"
              src={feature.icon}
              alt=""
              className={classes.featureIcon}
              draggable={false}
            />
          ) : feature.iconSlot ? (
            <Box className={classes.featureIconSlot} aria-hidden />
          ) : null}
          <Text className={classes.featureTitle}>{feature.title}</Text>
          {feature.subtitle ? (
            <Text className={classes.featureSubtitle}>{feature.subtitle}</Text>
          ) : null}
        </Box>
      </React.Fragment>
    ))}
  </Box>
);

export default FeatureBar;
